const setHomeData = (data) => {
    return {
        type: "SET_HOME_DATA",
        payload: data
    }
}

const setHomeAdsData = (data) => {
    return {
        type: "SET_HOME_ADS_DATA",
        payload: data
    }
}

const setHomeVideoData = (data) => {
    return {
        type: "SET_HOME_VIDEO_DATA",
        payload: data
    }
}

export default {
    setHomeData,
    setHomeAdsData,
    setHomeVideoData
}